import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  Events,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import { LOCDropdownItem } from "models/order-management/locDropdownItem";
import {
  DropdownItem,
  Order,
  OrderComponent,
  OrderResponse,
} from "models/order-management/models";
import { OrderFormState } from "pages/orders-entry-om/add-order/order-form-state";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import {
  OrderComponentInterface,
  OrderComponentPropertyUpdate,
  OrderCreateRequestUpdate,
} from "../order-components-interface";

@Component({
  selector: "level-of-care",
  templateUrl: "level-of-care.html",
})
export class LevelOfCareComponent implements OrderComponentInterface {
  /****************************************************************************
   * Inputs                                                                   *
   ****************************************************************************/
  @Input() orderComponent: OrderComponent;
  @Input() orderCreateRequest: Order;
  @Input() set orderFormState(orderFormState: OrderFormState) {
    this._orderFormState = orderFormState;
  }

  /****************************************************************************
   * Outputs                                                                  *
   ****************************************************************************/
  @Output() orderCreateRequestEvent =
    new EventEmitter<OrderCreateRequestUpdate>();
  @Output() orderFormStateEvent = new EventEmitter<OrderFormState>();
  @Output() isValidEvent = new EventEmitter<boolean>();
  @Output() dropdownItem = new EventEmitter<DropdownItem>();
  @Output() amendedOrderRequestEvent =
    new EventEmitter<OrderComponentPropertyUpdate>();

  /****************************************************************************
   * State                                                                    *
   ****************************************************************************/
  levelOfCareDropdownItems: LOCDropdownItem[] = [];
  selectedLOC: string;
  currentLOC = [];
  _orderFormState: OrderFormState;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public events: Events,
    public stateData: StateManagementService
  ) {}

  /****************************************************************************
   * Lifecycle Methods                                                        *
   ****************************************************************************/
  ngOnInit() {
    this._orderFormState.formType === "amendment"
      ? this.setAmendedValue()
      : null;
    this.setlevelOfCareDropdownItems(this.orderComponent);
  }

  /****************************************************************************
   * Getter Methods                                                           *
   ****************************************************************************/
  get isDisabled() {
    return (
      !this.orderComponent.properties[0].amendable &&
      this._orderFormState.formType === "amendment"
    );
  }

  /****************************************************************************
   * Setter Methods                                                           *
   ****************************************************************************/
  setlevelOfCareDropdownItems(orderComponent: OrderComponent): void {
    if (orderComponent.properties[0]) {
      const currentLOCOrder = OrderResponse.getCurrentLOC(
        this._orderFormState.locOrders
      );
      this.levelOfCareDropdownItems =
        orderComponent.properties[0].dropdownItems;
      if (currentLOCOrder) {
        let items = this.levelOfCareDropdownItems.map((item) => ({
          ...item,
          label:
            item.value == currentLOCOrder.levelOfCare
              ? item.label + ` - Current Level of Care`
              : item.label,
        }));
        this.levelOfCareDropdownItems = items;
      }
    }
  }

  setAmendedValue() {
    const componentField: string = this.orderComponent.properties[0].name;
    this.selectedLOC = this.orderCreateRequest[componentField];
    this.checkIsValid();
  }

  /****************************************************************************
   * Component Related Methods                                                *
   ****************************************************************************/
  onLevelOfCareChange(event: any) {
    if (this._orderFormState.formType !== "amendment") {
      this.orderCreateRequestEvent.emit({
        updates: { levelOfCare: event.value },
      });
    }
    this.orderFormStateEvent.emit({
      levelOfCare: event.value,
      careLocationType: null,
      careLocation: null,
    });
  }

  checkIsValid() {
    if (
      this.orderComponent.properties[0].required &&
      (!this.selectedLOC || this.selectedLOC.length === 0)
    ) {
      this.isValidEvent.emit(false);
    } else {
      this.isValidEvent.emit(true);
    }
  }

  /****************************************************************************
   * Cypress-Related ("data-cy") Methods                                      *
   ****************************************************************************/
  toKebabCase(label: string): string {
    if (label) {
      return label
        .replace(/^\s+|\s+$/gm, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();
    }
    return "";
  }

  createDataCyAttribute(component: string, option: string): string {
    return `${this.toKebabCase(component)}-option-${this.toKebabCase(option)}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-management/level-of-care/level-of-care.ts